<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">Parking</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params : params }" class="m-nav__link">
            <i class="m-nav__link-icon la la-home"></i>
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'parking', params : params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Parking
            </span>
          </router-link>
        </li>
      </ul>

    </bread-crumb>
    <div class="m-content">
      <payment v-if="showPaymentModal" @closePaymentModal="closePaymentModal" :transaction-details="transactionDetails"
               card-tx-type="pay-for-parking-card" mpesa-tx-type="pay-for-parking-mobile-money">
        <table slot="items" class="table table-striped table-bordered">
          <thead>
          <tr>
            <th>
              <strong>Service</strong>
            </th>
            <th>
              <strong>Amount</strong>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ selectedService.name }}</td>
            <td>KES {{ selectedService.amount }}</td>
          </tr>
          <tr>
            <td>
              <strong>TOTAL</strong>
            </td>
            <td>
              <strong>KES {{ transactionDetails.totalAmount }}</strong>
            </td>
          </tr>
          </tbody>
        </table>
      </payment>
      <ul class="nav nav-tabs m--margin-0" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#parking">
            Parking
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#history">
            Payment History
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div id="parking" class="active tab-pane">
          <div class="row">
            <div class="col-md-8">
              <div class="m-portlet">
                <div class="m-portlet__body">
                  <div class="m-form">
                    <div class="form-group" :class="{'has-danger': errors.has('location') }">
                      <label for="duration">Location</label>
                      <select v-model="subCountyId" @change="locationChanged" class="form-control m-input"
                              name="location" v-validate="'required'">
                        <option value=''>Select Location</option>
                        <option v-for='location in subCounties' :key="location.id" :value="location.id">{{ location.name
                          }}
                        </option>
                      </select>
                      <small v-show="errors.has('location')" class="form-control-feedback">{{ errors.first('location')
                        }}
                      </small>
                    </div>
                    <div class="form-group" :class="{'has-danger': errors.has('duration') }">
                      <label for="duration">Duration</label>
                      <select class="form-control m-input" v-model="duration" @change="durationChanged" name="duration"
                              v-validate="'required'">
                        <option value=''>Select Duration</option>
                        <option value='1'>Daily</option>
                        <option value='2'>Weekly</option>
                        <option value='3'>Monthly</option>
                        <option value='4'>Quarterly</option>
                        <option value='5'>Bi-Annual</option>
                        <option value='6'>Annual</option>
                        <option value='7'>One Off</option>
                        <option value='8'>Financial Year</option>
                      </select>
                      <small v-show="errors.has('duration')" class="form-control-feedback">{{ errors.first('duration')
                        }}
                      </small>
                    </div>
                    <div class="form-group"
                         :class="{'has-danger': errors.has('service'),'m-loader m-loader--primary m-loader--right':loading }">
                      <label for="duration">Service</label>
                      <select class="form-control m-input" v-model="service" @change="serviceChanged" name="service"
                              v-validate="'required'">
                        <option value=''>Select Service</option>
                        <option v-for='service in services' :key="service.id" :value="service.id">{{ service.name }}
                        </option>
                      </select>
                      <small v-show="errors.has('service')" class="form-control-feedback">{{ errors.first('service')
                        }}
                      </small>
                    </div>
                    <div class="form-group" :class="{'has-danger': errors.has('regNo') }">
                      <label for="">Registration Number</label>
                      <input type="text" class="form-control m-input" v-model="regNo" name="regNo"
                             data-vv-as="registration number" v-validate="'required|alpha_num|min:7|max:12'">
                      <small v-show="errors.has('regNo')" class="form-control-feedback">{{ errors.first('regNo') }}
                      </small>
                    </div>
                    <div class="m-portlet__foot p-0">
                        <div class="col-lg-12 m--align-right">
                          <div v-if="total > 0" class="btn btn-group m-btn-group" slot="actions">
                            <button class="btn btn-default" disabled>
                              KES {{ formatNumber(total) }}
                            </button>
                            <button @click="showPayModal" :disabled="total == 0" class="btn btn-info">
                              Pay
                            </button>
                          </div>
                        </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <instructions>
                <ol slot="instructions">
                  <li>Choose the location</li>
                  <li>Select the Duration</li>
                  <li>Select the Service</li>
                  <li>Enter vehicle registration number</li>
                  <li>Click on Pay to procced</li>
                </ol>
              </instructions>
            </div>
          </div>
        </div>
        <div id="history" class="tab-pane">
          <div class="m-portlet">
            <div class="m-portlet__body">
              <payment-history-table></payment-history-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../../api";
  import Modal from "../../Modal";
  import helper from "../../../helpers";
  import Instructions from "../../partials/Instructions";
  import BreadCrumb from "../../partials/BreadCrumb";
  import payment from "../../checkout/Payment";
  import paymentHistoryTable from "./datatables/PaymentHistory";

  export default {
    name: "Parking",
    data() {
      return {
        loading: false,
        duration: "",
        service: "",
        regNo: "",
        total: 0,
        services: [],
        selectedService: {},
        modules: [],
        showPaymentModal: false,
        phoneNo: JSON.parse(window.localStorage.getItem("user")).phoneNo,
        subCountyId: "",
        subCounties: [],
        categoryId: "1",
        token: this.$store.state.token || window.localStorage.getItem("token"),
        params: this.$route.params,
        transactionDetails: {}
      };
    },
    components: {
      Instructions,
      BreadCrumb,
      payment,
      paymentHistoryTable
    },
    methods: {
      formatNumber(number) {
        return helper.formatNumber(number);
      },
      locationChanged() {
        if (this.duration.length === 0) {
          return false;
        }
        this.getServices();
      },
      toggleLoading() {
        this.loading = this.loading ? false : true;
      },
      durationChanged() {
        if (this.subCountyId.length === 0) {
          return false;
        }
        this.getServices();
      },
      findService(service) {
        return service.id === this.service;
      },
      serviceChanged() {
        this.selectedService = this.services.find(this.findService);
        this.total = this.selectedService.amount;
      },
      resetItems() {
        this.services = [];
        this.selectedService = {};
        this.service = "";
        this.total = 0;
      },
      getServices() {
        const txType = "get-services-unstructured";
        this.resetItems();
        this.toggleLoading();
        let module = helper.getModuleId("Parking");
        let data = {
          token: this.token,
          categoryId: module.id,
          duration: this.duration,
          subCountyId: this.subCountyId
        };
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              this.toggleLoading();
              this.services = response.data.services;
            } else {
              this.toggleLoading();
              this.services = [];
            }
          })
          .catch(error => {
            this.toggleLoading();
            console.log(error);
          });
      },
      getSubCounties() {
        const txType = "get-sub-counties";
        api
          .request(txType, {token: this.token, countyId: this.params.countyId})
          .then(response => {
            if (response.data.status === "00") {
              this.subCounties = response.data.subCounties;
            } else {
              this.subCounties = [];
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      resetForm() {
        this.subCountyId = "";
        this.duration = "";
        this.serviceId = "";
        this.regNo = "";
        this.$validator.reset();
      },
      showPayModal() {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.transactionDetails = {
              token: this.token,
              moduleId: String(helper.getModuleId("Parking").id),
              subCountyId: this.subCountyId,
              regNo: this.regNo,
              serviceId: String(this.selectedService.id),
              amount: String(this.selectedService.amount),
              totalAmount: String(this.selectedService.amount)
            };
            document.body.classList.add("modal-open");
            this.showPaymentModal = true;
          }
        });
      },
      closePaymentModal() {
        document.body.classList.remove("modal-open");
        this.showPaymentModal = false;
        this.transactionDetails = {};
        this.selectedService = {};
        this.service = "";
        this.total = 0;
        this.resetForm();
      }
    },
    created: function () {
      this.getSubCounties();
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/services/parking/Parking.vue